import React from 'react';

const isWithinNextDays = (isoDate, days) => {
  if (!isoDate) return false;
  const [y, m, d] = isoDate.split('-').map(Number);
  const due = new Date(y, m - 1, d);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const diffDays = (due - today) / (1000 * 60 * 60 * 24);
  return diffDays >= 0 && diffDays <= days;
};

const isWithinLastDays = (isoDatetime, days) => {
  if (!isoDatetime) return false;
  const cutoff = new Date();
  cutoff.setDate(cutoff.getDate() - days);
  return new Date(isoDatetime) >= cutoff;
};

/**
 * At-a-glance dashboard for the current board: a few count tiles plus a
 * simple bar chart of how many tickets sit in each column. Deliberately
 * plain (no charting library) -- CSS-width bars are enough for "which
 * column is backed up" at a glance.
 */
const SummaryView = ({ tickets, columns }) => {
  const tiles = [
    { label: 'Total tickets', value: tickets.length },
    { label: 'Completed', value: tickets.filter((t) => t.is_completed).length },
    { label: 'Updated in last 7 days', value: tickets.filter((t) => isWithinLastDays(t.updated_at, 7)).length },
    { label: 'Created in last 7 days', value: tickets.filter((t) => isWithinLastDays(t.created_at, 7)).length },
    { label: 'Due within 3 days', value: tickets.filter((t) => !t.is_completed && isWithinNextDays(t.due_date, 3)).length },
  ];

  const byColumn = columns.map((col) => ({
    ...col,
    count: tickets.filter((t) => t.column === col.id).length,
  }));
  const maxColumnCount = Math.max(1, ...byColumn.map((c) => c.count));

  return (
    <div className="summary-view">
      <div className="summary-tiles">
        {tiles.map((tile) => (
          <div key={tile.label} className="summary-tile">
            <div className="summary-tile-value">{tile.value}</div>
            <div className="summary-tile-label">{tile.label}</div>
          </div>
        ))}
      </div>

      <div className="section-title">Status breakdown</div>
      <div className="summary-status-chart">
        {byColumn.map((col) => (
          <div key={col.id} className="summary-status-row">
            <span className="summary-status-label">{col.name}</span>
            <div className="summary-status-bar-track">
              <div className="summary-status-bar-fill" style={{ width: `${(col.count / maxColumnCount) * 100}%` }} />
            </div>
            <span className="summary-status-count">{col.count}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SummaryView;
